/**
 * The models a plan engine can run, by id (engines T3, spec 2026-10-06 §5.1).
 *
 * PROVIDERS_BY_HARNESS gates a model by its provider, which is enough for Claude Code: every
 * Anthropic model in our registry is one the Claude Code CLI can run. It is not enough for Codex:
 * `['openai']` would let in every Vestra GPT row, and the person's ChatGPT plan runs only the
 * models the pinned Codex CLI lists (`model/list`). So an engine may also name its models here, and
 * every catalog and pin check intersects the provider gate with this list.
 */
import type { HarnessId } from '../harness/ids.js';

/** The ids an engine runs, when it has a list. No entry means the provider gate alone decides. */
export const ENGINE_MODEL_IDS: Readonly<Partial<Record<HarnessId, readonly string[]>>> = {
  // The pinned Codex CLI's visible `model/list` (0.160.0). The first is its default.
  codex: ['gpt-6.1-sol', 'gpt-6-astra', 'gpt-6-sol', 'gpt-6-luna', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-5.5'],
};

/** True when the engine has no allowlist (native, claude_code by provider) or the id is on it. */
export function engineAllowsModel(engine: HarnessId, modelId: string): boolean {
  const ids = ENGINE_MODEL_IDS[engine];
  return ids === undefined || ids.includes(modelId);
}
